import {
  flow, keys, every, clone, nthArg,
  mapKeys, defaults, isBoolean, mapValues,
  isPlainObject, camelCase, upperFirst
} from 'lodash-es'

import {
  safePick,
  toObject,
  toBoolean
} from '../utils/bits'

const capitalCase = flow(camelCase, upperFirst)

import StrictObj from '../utils/strict-obj'

export function toFeatures(v) {
  const obj = toObject(v)
  const def = {
    GalleriesBranding: false,
    GalleriesLanguages: false,
    GalleriesCustomStyles: false,
    GalleriesTextOverrides: false,
    GalleriesCustomColumns: false,
    AdvancedGalleryCustomisation: false
  }

  if (!isPlainObject(obj)) {
    return StrictObj(clone(def))
  }

  const capitalized = mapKeys(obj, flow(nthArg(1), capitalCase))
  const corrected = mapValues(capitalized, toBoolean)
  const sanitized = safePick(corrected, keys(def))
  const completed = defaults(sanitized, def)
  return StrictObj(completed)
}

export function isFeatures(v) {
  return true
    && isPlainObject(v)
    && every(v, isBoolean)
}
